import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { tempMeeApi } from '~/services/api';

/**
 * Drops a partial Sign Up session (POST /users succeeded but wizard
 * unfinished) and sends the user back to /login.
 */
export const useCancelPartialSession = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return () => {
    const refreshToken = localStorage.getItem('refresh_token_dental');

    if (refreshToken) {
      // POST /users tokens expire in 120s; the DELETE often fails. Fire-and-forget.
      tempMeeApi.delete('/auth-service/sessions', { data: { refreshToken } }).catch(() => {});
    }

    localStorage.removeItem('refresh_token_dental');
    localStorage.removeItem('selectedOfficeId');

    dispatch({ type: 'LOGOUT_ACTION_SUCCESS' });

    navigate('/login');
  };
};
